import * as ActionTypes from './constants';

export const defaultState = () => {
  return {
    error: null,
    exportAsXlsxPending: false,
  };
};

export function leads(state = defaultState(), action) {
  const { error, type } = action;

  if (type === ActionTypes.EXPORT_LEADS_AS_XLSX_REQUEST) {
    return {
      ...state,
      exportAsXlsxPending: true,
    };
  }

  if (type === ActionTypes.EXPORT_LEADS_AS_XLSX_SUCCESS) {
    return {
      ...state,
      exportAsXlsxPending: false,
      error: null,
    };
  }

  if (type === ActionTypes.EXPORT_LEADS_AS_XLSX_ERROR) {
    return {
      ...state,
      exportAsXlsxPending: false,
      error,
    };
  }

  return state;
}
